'use client';

import { Toaster as Sonner } from 'sonner';

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      theme="light"
      className="toaster group"
      position="top-right"
      toastOptions={{
        classNames: {
          toast:
            'bg-white text-[#1f2329] border border-[#e5e6eb] !border-l-4 shadow-lg rounded-lg',
          description: 'text-[#646a73]',
          icon: 'text-[#8f959e]',
          actionButton:
            'bg-[#3370ff] text-white',
          cancelButton:
            'bg-white text-[#1f2329] border border-[#e5e6eb]',
          success:
            '!border-l-[#00b42a]',
          error:
            '!border-l-[#f53f3f]',
          warning:
            '!border-l-[#ff7d00]',
          info:
            '!border-l-[#3370ff]',
          loading:
            '!border-l-[#3370ff]',
          default:
            'border-l-[#c9cdd4]',
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
